module.exports = __webpack_public_path__ + "img/담배하나찔러봐라.2bd4999b.png";